import { useState } from "react";
import AddOptionsForm from "../../Form/AddOptionsForm";
import AddProductsFrom from "../../Form/AddProductsFrom";
import "../Modal.css";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ModalUpdateProfile = ({ isVisible, onClose, user, closeModal }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
  });
  const [profilePicture, setprofilePicture] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setprofilePicture(e.dataTransfer.files[0]);
      e.dataTransfer.clearData(); // Clear data after handling drop
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setprofilePicture(e.target.files[0]);
    }
  };

  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("aircnc-token");
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("address", formData.address);
      if (profilePicture) {
        formDataToSend.append("profilePicture", profilePicture);
      }

      const response = await fetch(
        `https://server-gs.vercel.app/user-update/${user.email}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          title: "Success!",
          text: "Profile added successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        })
        closeModal(); // Close the modal
      } else {
        toast.error(data.message || "Failed to update profile");
      }
    } catch (err) {
      toast.error("An error occurred while updating profile");
    }
  };


  if (!isVisible) return null;
  return (
    <div
      className="fixed inset-0  bg-opacity-75 flex justify-center items-center z-50"
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="bg-white rounded-lg shadow-custom-full w-[1000px] mx-5 sm:mx-auto">
        <div className="flex justify-between py-3 px-5 items-center border-b shadow-md bg-blue-500">
          <h1 className="text-white text-xl font-roboto text500">
            Update Profile
          </h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="bg-green p-5 h-[620px] overflow-y-auto shadow-lg ">
          <div className="p-5">
            {success && <div className="text-green-600">{success}</div>}
            {error && <div className="text-red-600">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="flex flex-col">
                <label className="font-roboto text-xl text-gray-900">
                  Name:
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="border p-2 w-[60%] rounded-md font-roboto text-lg h-10 border-gray-500"
             
                />
              </div>
              <div className="flex flex-col">
                <label className="font-roboto text-xl text-gray-900">
                  Phone:
                </label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="border p-2 w-[60%] rounded-md font-roboto text-lg h-10 border-gray-500"
                
                />
              </div>
              <div className="flex flex-col">
                <label className="font-roboto text-xl text-gray-900">
                  Address:
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="border p-2 w-[60%] rounded-md font-roboto text-lg h-10 border-gray-500"
             
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xl text-black font-roboto ">
                  Upload profile picture
                </label>
                <div
                  className={`px-6 py-16 border-2 rounded-lg mt-2 text-center transition-colors duration-200 ${
                    isDragging
                      ? "border-blue-500 bg-blue-100"
                      : "border-gray-300"
                  }`}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  {profilePicture ? (
                    <div className="flex flex-col items-center">
                      <img
                        src={URL.createObjectURL(profilePicture)}
                        alt="Selected"
                        className="w-32 h-32 object-cover mb-4"
                      />
                    </div>
                  ) : (
                    <p className="text-gray-500">
                      Drag & Drop a file here or click to select
                    </p>
                  )}
                  <input
                    type="file"
                    id="fileInput"
                    className="hidden"
                    onChange={handleFileChange}
                    name="profilePicture"
                  />
                  <label
                    htmlFor="fileInput"
                    className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                  >
                    Browse File
                  </label>
                </div>
              </div>
              <button
                type="submit"
                className="bg-blue-500 text-white p-2 rounded"
              >
                Update Profile
              </button>
            </form>
          </div>
        </div>
        <div className="flex  mx-5"></div>
      </div>
    </div>
  );
};

export default ModalUpdateProfile;
